var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import objectPath from 'object-path';
import layoutConfig from '@/core/config/Config';
import { Mutations } from '@/store/enums/StoreEnums';
import { Mutations as HRGSGlobalMutations } from '@/store/enums/hrgs/GlobalEnum';
import { Mutation, Module, VuexModule } from 'vuex-module-decorators';
let ConfigModule = class ConfigModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.config = layoutConfig;
        this.initial = layoutConfig;
        this.modalLoading = false;
        this.autoSaveDraft = false;
        this.autoSaveDraftTriggered = false;
    }
    /**
     * Get config from layout config
     * @returns {function(path, defaultValue): *}
     */
    get layoutConfig() {
        return (path, defaultValue) => {
            return objectPath.get(this.config, path, defaultValue);
        };
    }
    get isAutoSaveDraft() {
        return this.autoSaveDraft;
    }
    get isAutoSaveDraftTriggered() {
        return this.autoSaveDraftTriggered;
    }
    get isModalLoading() {
        return this.modalLoading;
    }
    [_a = Mutations.RESET_LAYOUT_CONFIG]() {
        this.config = Object.assign({}, this.initial);
    }
    [_b = Mutations.OVERRIDE_LAYOUT_CONFIG]() {
        this.config = this.initial = Object.assign({}, this.initial, JSON.parse(window.localStorage.getItem('config') || '{}'));
    }
    [_c = Mutations.SET_AUTOSAVE_DRAFT](payload) {
        this.autoSaveDraft = payload;
    }
    [_d = HRGSGlobalMutations.SET_MODAL_LOADING](payload) {
        this.modalLoading = payload;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ConfigModule.prototype, _d, null);
ConfigModule = __decorate([
    Module
], ConfigModule);
export default ConfigModule;
